<template>
  <div class="CategoryList">
      <div class="container">
        <StorySlider :stories="response.stories"/>
        <ImageSlider :images="response.sliders" v-if="755 < screen" />
        <ImageSliderMobile :images="response.sliders" v-if="755 >= screen" />
        <div class="row justify-content-center">
            <div class="col-md-4 col-sm-6 col-12 mb-4 position-relative" :key="(category,index)" v-for="(category,index) in $categories">
              <router-link :to="'/category/' + category.slug">
                <img class="w-100" v-lazy="$MEDIA + category.header" :alt="category.name">
              </router-link>
            </div>
        </div>
        <div class="mt-3 mb-5">
          <h2 class="text-center my-4">دسته‌بندی‌ها</h2>
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation" :key="(category,index)" v-for="(category,index)  in $categories">
              <button :aria-label="category.name" class="nav-link" :class="index === 1 ? 'active' : ''" data-bs-toggle="tab" :data-bs-target="'#c'+index" type="button" role="tab">{{category.name}}</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show" :class="index === 1 ? 'active' : ''" :id="'c'+index" role="tabpanel" :key="(category,index)" v-for="(category,index)  in $categories">
              <BrandCarousel :objects="category.brands"/>
              <ProductCarousel :objects="category.bestProducts" :more="'/category/' + category.slug" />
            </div>
          </div>
        </div>
        <div class="mt-3 mb-5">
          <h2 class="text-center my-4"> کالکشن‌ها</h2>
          <ul class="nav nav-tabs" id="myTab2" role="tablist">
            <li class="nav-item" role="presentation" :key="(category,index)" v-for="(category,index)  in $categories">
              <button :aria-label="category.name" class="nav-link" :class="index === 0 ? 'active' : ''" v-if="(collections.filter(c => c.categories.includes(parseInt(category.id))).length !=0)" data-bs-toggle="tab" :data-bs-target="'#collections'+index" type="button" role="tab">{{category.name}}</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div class="tab-pane fade show" :class="index === 0 ? 'active' : ''" :id="'collections'+index" role="tabpanel" :key="(category,index)" v-for="(category,index)  in $categories">
              <div v-if="collections.filter(c => c.categories.includes(parseInt(category.id))).length !=0">
                  <CollectionCarousel :collections="collections.filter(c => c.categories.includes(parseInt(category.id)))" />
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3 mb-5">
          <h2 class="text-center my-4">جدیدترین محصولات</h2>
          <ProductCarousel :objects="productsNew"/>
        </div>
        <hr />
        <div class="mt-3 mb-5">
          <h2 class="text-center my-4">پرفروش ترین محصولات</h2>
          <ProductCarousel :objects="productsSell"/>
        </div>
        <hr />
        <div class="mt-3 mb-5">
          <h2 class="text-center my-4">پرطرفدار‌ها از دید کاربران</h2>
          <ProductCarousel :objects="productsScore"/>
        </div>
        <PageContent mode="CategoryList" />
      </div>
  </div>
</template>
<script>
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'
import ProductCarousel from '@/components/ProductCarousel.vue'
import PageContent from '@/components/PageContent.vue'
import BrandCarousel from '@/components/BrandCarousel.vue'
import CollectionCarousel from '@/components/CollectionCarousel.vue'
import StorySlider from '@/components/StorySlider.vue'

export default {
  name: 'CategoryList',
  components: {
    ImageSlider,
    ImageSliderMobile,
    ProductCarousel,
    PageContent,
    BrandCarousel,
    CollectionCarousel,
    StorySlider
  },
  data () {
    return {
      response: {},
      productsNew: null,
      productsSell: null,
      productsScore: null,
      collections: [],
      screen: screen.width
    }
  },
  mounted () {
    const query = `{
      productsNew:products(filters:{
        count:12,
        order: "-date_update",
        available: true
      }){
        id,
        available,
        slug,
        name,
        image:PNG,
        mlActivation,
        specialTag,
        isOffInt,
        priceAfterOff,
        priceBeforeOff,
        categorySlug,
        subCategorySlug,
        categoryId:categoryId,
      },
      productsScore:products(filters:{
        count:12,
        order: "-score",
        available: true,
      }){
        id,
        available,
        slug,
        name,
        image:PNG,
        mlActivation,
        specialTag,
        isOffInt,
        priceAfterOff,
        priceBeforeOff,
        categorySlug,
        subCategorySlug,
        categoryId:categoryId,
      },
      productsSell:products(filters:{
        count:12,
        order: "-sell",
        available: true,
      }){
        id,
        available,
        slug,
        name,
        image:PNG,
        mlActivation,
        specialTag,
        isOffInt,
        priceAfterOff,
        priceBeforeOff,
        categorySlug,
        subCategorySlug,
        categoryId:categoryId,
      },
      collections:collections(filters:{}){
        slug,
        description,
        name,
        image,
        categories
      },
      meta(key:"${this.$options.name}") {
        seoTitle
        seoKeyword
        seoDescription
      }
      sliders (key: "CategoryList") {
        imageMobile
        image
        alt
        link
      }
      stories (key: "CategoryList") {
        id
        videoCover
        link
        video
        prev
        next
      }
    }
      `
    this.$fetchGraphQL(query)
      .then((response) => {
        this.response = response.data
        this.setMetaByObj(response.data.meta)
        this.collections = response.data.collections
        this.productsScore = response.data.productsScore
        this.productsNew = response.data.productsNew
        this.productsSell = response.data.productsSell
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.drop-shadow{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
}
img{
  width: -webkit-fill-available;
  border-radius: 24px;
  box-shadow: #afafaf 0px 0px 20px 0px;
}
.title-c{
  color: white;
  background: #808080b3;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 12px;
}
.nav-link{
  color: #bdbdbd;
}
.nav{
  justify-content: center;
}
.nav-link:hover{
  border-color: transparent;
}
.nav-item{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
  margin: 5px 0px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  color: black;
  background-color: #e8acd4;
  border-color: transparent;
  clip-path: polygon(20% 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 50%);
}
.nav-tabs{
  border:none;
}

.nav-link{
    border: solid #e8acd4 2px;
    color: black;
    padding: 6px 10px;
    border-radius: 24px;
    width: max-content;
    transition: 0.4s;
}
.nav-link:hover{
    background-color: #e8acd4;
    color: black;
    padding: 6px 13px;
    border-radius: 24px;
    width: max-content;
}
</style>
